import { STATUS_MAP } from './employeeConstants';

/**
 * Returns the status for a worker based on their current absences.
 */
export const getStatus = (workerId, absences) => {
    const workerAbs = absences[workerId] || [];
    const now = new Date();
    
    // Find active absence
    const current = workerAbs.find(a => {
        const start = new Date(a.start_datetime);
        const end = new Date(a.end_datetime);
        return now >= start && now <= end;
    });

    if (current) {
        let type = (current.absence_type || '').toLowerCase();
        
        // Normalize / Map to the defined absence types
        if (type === 'dienstreise') type = 'termin';
        if (type === 'abwesend' || !STATUS_MAP[type]) type = 'sonstiges';

        return {
            ...STATUS_MAP[type],
            type,
            absence: current
        };
    }
    return STATUS_MAP.present;
};

/**
 * Formats license categories for display.
 */
export const formatLicenses = (emp) => {
    const cats = (emp.license_categories || []).join(', ');
    const classVal = emp.license_class || '';
    if (!cats && !classVal) return '';
    if (!cats) return classVal;
    if (!classVal) return cats;
    return `${classVal}, ${cats}`;
};

/**
 * Returns the replacement name by ID.
 */
export const getReplacementName = (id, employees) => {
    if (!id) return '—';
    const found = employees.find(e => String(e.id) === String(id));
    return found ? found.name : '—';
};
